import { toast } from 'react-toastify';
import { apiChatTS as http } from '../http';

class ServiceCRUDChatTS {
  constructor(path) {
    this.path = path;
  }

  /**
   * Busca relatórios no flex-portal-chat-ts
   * @param {'analytical' | 'synthetic'} type
   */
  getAllReportsType(type, page, queryParams = {}, quantity = 10) {
    return http.get(`${this.path}/${type}`, {
      params: {
        quantity: quantity,
        page: page,
        ...queryParams
      }
    });
  }

  /**
   * Downloads report in CSV/XLSX format
   * @param {'analytical' | 'synthetic'} type - Report type
   * @param {'csv' | 'xlsx'} format - File format
   * @param {Object} queryParams - Query parameters
   */
  downloadReport(type, format, queryParams = {}) {
    return http.get(`${this.path}/${type}/${format}`, {
      params: queryParams,
      responseType: 'blob'
    });
  }

  /**
   * Gets download URL for report
   * @param {'analytical' | 'synthetic'} type - Report type
   * @param {'csv' | 'xlsx'} format - File format
   * @param {Object} queryParams - Query parameters
   * @returns {string} Download URL
   */
  getDownloadUrl(type, format, queryParams = {}) {
    const baseURL = http.defaults.baseURL || '';
    const queryString = new URLSearchParams(queryParams).toString();
    return `${baseURL}${this.path}/${type}/${format}?${queryString}`;
  }

  /**
   * Gera URL para download de relatório de pausas em nova janela
   * Similar ao método getDownloadsTransfersNewWindow do relatório de conversas
   * @param {Object} queryParams - Query parameters
   * @param {string} fileType - Tipo do arquivo ('csv' ou 'xlsx')
   * @returns {string} Download URL
   */
  getDownloadsPauseReportNewWindow(queryParams = {}, fileType = 'csv') {
    const searchParams = new URLSearchParams();

    const mappedParams = {
      startDate: queryParams.startDate,
      endDate: queryParams.endDate
    };

    if (queryParams.pauseId) {
      mappedParams.pauseId = queryParams.pauseId;
    }

    if (queryParams.agentLogin) {
      mappedParams.agentLogin = queryParams.agentLogin;
    }

    for (const [key, value] of Object.entries(mappedParams)) {
      if (Array.isArray(value)) {
        value.forEach((val) => searchParams.append(key, val));
      } else {
        searchParams.append(key, value);
      }
    }

    searchParams.append('jwt', localStorage.getItem('token'));
    return `${http.defaults.baseURL}${
      this.path
    }/analytical/${fileType}?${searchParams.toString()}`;
  }

  /**
   * Gets download URL for report with auth token
   * @param {'analytical' | 'synthetic'} type - Report type
   * @param {'csv' | 'xlsx'} format - File format
   * @param {Object} queryParams - Query parameters
   * @returns {string} Download URL with auth token
   */
  getDownloadUrlWithAuthToken(type, format, queryParams = {}) {
    const baseURL = http.defaults.baseURL || '';
    const searchParams = new URLSearchParams();

    // Add all query params
    for (const [key, value] of Object.entries(queryParams)) {
      if (Array.isArray(value)) {
        value.forEach((val) => searchParams.append(key, val));
      } else {
        searchParams.append(key, value);
      }
    }

    // Add JWT token
    searchParams.append('jwt', localStorage.getItem('token'));

    return `${baseURL}${
      this.path
    }/${type}/${format}?${searchParams.toString()}`;
  }

  /**
   * Busca dados de monitoramento para filas específicas
   * @param {string[]} queueNames - Nomes das filas a serem monitoradas
   * @returns {Promise<Object>} Dados de monitoramento
   */
  getMonitoringChatQueues(queueNames = [], channels = [], agents = []) {
    return http.get(this.path, {
      params: {
        queueNames: JSON.stringify(queueNames),
        channels: JSON.stringify(channels),
        agentLogins: JSON.stringify(agents.map((a) => a.login || a))
      }
    });
  }

  /**
   * Realiza uma chamada GET ao `this.path` acrescido de um caminho `path` opcional
   */
  get(path = '') {
    return http.get(`${this.path}${path}`);
  }

  /**
   * Realiza uma chamada PUT ao `this.path` acrescido de um caminho `path` opcional
   */
  put(path = '', payload) {
    return http.put(`${this.path}${path}`, payload);
  }

  /**
   * Realiza uma chamada POST ao `this.path` acrescido de um caminho `path` opcional
   */
  post(path = '', payload) {
    return http.post(`${this.path}${path}`, payload);
  }

  // Busca um chat específico pelo ID
  getChatById(id) {
    return http.get(`${this.path}/chat/finish/${id}`);
  }

  getDownloadsCsvSyntheticDetails(
    typeOfReport,
    fileExtension,
    queryParams = {},
    jwt
  ) {
    if (!typeOfReport || !fileExtension || !jwt) {
      toast.error(`Algo deu errado ao fazer o download do relatório.`);
      throw new Error(
        'Missing required parameters: typeOfReport, fileExtension, and jwt are required.'
      );
    }
    return http.get(`/chat/details/report/synthetic/csv`, {
      params: {
        ...queryParams,
        jwt: localStorage.getItem('token'),
        request_by: localStorage.getItem('login')
      },
      responseType: 'arraybuffer'
    });
  }

  /**
   * Busca a relação de agentes logados e suas respectivas filas
   * Busca também as filas e seus respectivos agentes logados
   * Rota: /flex-chat-integration/api/agent-queues-queue-agents
   */
  getAgentsLoggedInQueues() {
    return http.get(`/agent-queues-queue-agents`);
  }
}

export { ServiceCRUDChatTS };
export default ServiceCRUDChatTS;
